var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2HomeAirRegeneration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 3.63L3 25.89V69h70V25.9L38 3.63zM69 65H7V28.1L38 8.37l31 19.71V65zM38 24.27a17 17 0 0117 16.94h5.46l-7.69 8-7.31-8H51a13 13 0 10-26 0c0 7.4 5.06 13 12 13v4c-9.23 0-16-7.3-16-17a17 17 0 0117-16.94z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Home_air_regeneration.317f2473.svg";
export { SvgE2HomeAirRegeneration as ReactComponent };